export const ANALYTICS_SENSITIVE_QUERY_PARAMS = [
  "token",
  "access_token",
  "refresh_token",
  "id_token",
  "oauth_token",
  "oauth_verifier",
  "code",
  "state",
  "signature",
  "redirect",
  "email",
  "phone",
  "name",
] as const;

export function sanitizeAnalyticsUrl(rawUrl: string): string {
  try {
    const url = new URL(rawUrl);
    const sensitive = new Set<string>(ANALYTICS_SENSITIVE_QUERY_PARAMS);
    const queryKeys = Array.from(url.searchParams.keys());

    for (const key of queryKeys) {
      if (sensitive.has(key.toLowerCase())) url.searchParams.delete(key);
    }

    url.hash = "";
    return url.toString();
  } catch {
    return rawUrl.split("?", 1)[0] ?? rawUrl;
  }
}
